const l = {
  name: "XcodePath",
  dimensions: { width: 35, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 35 40" style="enable-background:new 0 0 35 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M27.7,9.5L27,11.2V21c0,2.8-2.2,5-5,5h-1.2c-0.4,1-1.2,1.7-2.2,2c-1.5,0.5-3.2-0.2-4-1.6l0,0
			c-0.1-0.1-0.1-0.2-0.2-0.4H8c-2.8,0-5-2.2-5-5V7c0-2.8,2.2-5,5-5h10c0.5-0.7,1.3-1.3,2.1-1.6l0,0c1.2-0.5,2.6-0.5,3.8,0l0,0
			l3.7,1.5c1.2,0.5,1.9,1.7,1.9,2.9l0.1,0.1c0.5,0.2,1.1,0,1.3-0.5l0.4-0.9l1.8,0.8l0,0c1.5,0.6,2.3,2.4,1.6,3.9l0,0l-1.1,2.8
			c-0.6,1.5-2.4,2.3-3.9,1.6l0,0l-1.8-0.8l0.4-0.9c0.1-0.3,0.1-0.5,0-0.8l0,0l0,0C28.2,9.8,28,9.6,27.7,9.5z M20.9,2.2
			c-0.4,0.2-0.8,0.5-1.1,0.8c1,0.5,1.8,1.2,2.3,2c0.5,0.7,0.9,1.6,0.9,2.5l0.3,0.1l2.6,1.1l0.8-1.8l1.8,0.8c0.8,0.3,1.3,0.9,1.6,1.6
			c0.2,0.4,0.2,0.9,0.2,1.3l0.2,0.1c0.5,0.2,1.1,0,1.3-0.5l1.1-2.8l0,0c0.2-0.5,0-1.1-0.5-1.3L32.2,6c-0.8,0.9-2.2,1.3-3.4,0.8L27,6
			l0.4-0.9c0.2-0.5,0-1.1-0.5-1.3l-3.7-1.5l0,0C22.4,1.9,21.6,1.9,20.9,2.2z M17,4H8C6.3,4,5,5.3,5,7v14c0,1.7,1.3,3,3,3h6.3
			c0.1-0.3,0.1-0.5,0.3-0.8L17,18h-4.4l-2.3,3.5l-1.7-1.1l1.6-2.5H9v-2h2.5l2.3-3.6l-3.2-4.9l1.7-1.1l2.7,4.1l2.7-4.1l1.7,1.1
			l-3.2,4.9l2,3.1l3.1-6.5l-0.9-0.4l0.4-0.9C21,7.5,21,6.9,20.4,6.2c-0.5-0.7-1.4-1.4-2.5-1.8L17,4L17,4z M15,14.3L13.9,16h2.2
			L15,14.3z M22,24c1.7,0,3-1.3,3-3v-6.9L21.5,24H22z M16.3,24.1c-0.2,0.4-0.2,0.9,0,1.3c0.3,0.6,1,0.9,1.7,0.7l0,0
			c0.4-0.1,0.8-0.5,1-0.9l5.2-14.9l-1-0.4L16.3,24.1z"/>
		<path class="st0" d="M0,30h3c1.7,0,3,1.3,3,3c0,1.7-1.3,3-3,3H2v4H0V30z M3,34c0.5,0,1-0.5,1-1s-0.5-1-1-1H2v2H3z"/>
		<path class="st0" d="M14,40V30H8v10h2v-4h2v4H14z M12,34h-2v-2h2V34z"/>
		<path class="st0" d="M22,30v2h-2v8h-2v-8h-2v-2H22z"/>
		<path class="st0" d="M26,30h-2v10h2v-4h2v4h2V30h-2v4h-2V30z"/>
	</g>
</g>
</svg>
  `
};
export {
  l as XcodePath
};
